import React from 'react';
import { observer } from 'mobx-react';

import Notice from './display/Notice';
import Loading from './display/Loading';
import Options from './display/Options';

export default observer(({ state, ...rest }) => {
  const { shippingOptions, isLoading, lookupError, lookupCanceled, hasNoOptions } = state;

  return isLoading ? (
    <Loading {...rest} />
  ) : hasNoOptions ? (
    <Notice icon="frown-o" color="red" {...rest}>
      Not available at that address
    </Notice>
  ) : lookupError ? (
    <Notice icon="exclamation-circle" color="red" {...rest}>
      Error loading shipping rates
    </Notice>
  ) : lookupCanceled || !shippingOptions.length ? (
    <Notice icon="info-circle" {...rest}>
      Please fill in your address above
    </Notice>
  ) : shippingOptions.length ? (
    <Options {...rest} state={state} />
  ) : null;
});
